import { useForm } from "../../../provider/Form/FormProvider";
import { AbstractCase } from "../../../types/Entities/AbstractCase";
import Group from "../../Wizard/Group";
import { translate } from "../../../services/translations/translations";
import { isIban, isMoney, requiredValidator } from "../../../services/validationRules";
import Grid from "@mui/material/Grid";
import React from "react";
import MoneyIcon from "../../../assets/icons/contract/toggleable/IconMoneyEnforce";
import GoodsIcon from "../../../assets/icons/contract/toggleable/IconGoodsEnforce";
import FormLegend from "../Common/FormLegend/FormLegend";
import ValidatorTextField from "../../FormFields/ValidatorTextField";
import IconMoneyAndGoods from "../../../assets/icons/contract/toggleable/IconMoneyAndGoodsEnforce";
import InputAdornment from "@mui/material/InputAdornment";
import IconQuestionmark from "../../../assets/icons/common/toggleable/IconQuestionmark";
import wizardStyle from "../wizardStyle";
import ClientClaimedData from "../AbstractLitigationCase/ClientClaimedData";
import { IbanInput } from "../../FormFields/MaskedInputs/IbanInput";

type EmploymentContractBaseEnforceClaimProps = {
  product: AbstractCase;
};

export default function EmploymentContractBaseEnforceClaim({ product }: EmploymentContractBaseEnforceClaimProps) {
  const { values } = useForm();

  return (
    <>
      <Grid sx={wizardStyle.gridTopSpaced} size={12}>
        <Group
          type={"radio"}
          name={"subjectOfDispute"}
          question={translate("employmentContract.subjectOfDispute.question", values)}
          options={[
            {
              labelText: translate("employmentContract.subjectOfDispute.options.money.label", values),
              labelIcon: <MoneyIcon />,
              labelIconActive: <MoneyIcon active />,
              value: "money",
            },
            {
              labelText: translate("employmentContract.subjectOfDispute.options.goods.label", values),
              labelIcon: <GoodsIcon />,
              labelIconActive: <GoodsIcon active />,
              value: "goods",
            },
            {
              labelText: translate("employmentContract.subjectOfDispute.options.moneyAndGoods.label", values),
              labelIcon: <IconMoneyAndGoods sx={{ width: 300 }} />,
              labelIconActive: <IconMoneyAndGoods sx={{ width: 300 }} active />,
              value: "moneyAndGoods",
            },
            {
              labelText: translate("employmentContract.subjectOfDispute.options.other.label", values),
              labelIcon: <IconQuestionmark />,
              labelIconActive: <IconQuestionmark active />,
              value: "other",
            },
          ]}
          validators={[requiredValidator("Bitte wählen Sie eine der angezeigten Antworten aus")]}
        />
      </Grid>
      {(values.subjectOfDispute === "money" || values.subjectOfDispute === "moneyAndGoods") && (
        <>
          <Grid sx={wizardStyle.gridTopSpaced} size={12}>
            <FormLegend>Wie viel Geld möchten Sie einfordern?</FormLegend>
          </Grid>
          <Grid size={12}>
            <ValidatorTextField
              label={translate("employmentContract.claimedAmountClient.label", values)}
              name="claimedAmountClient"
              validators={[
                {
                  validator: isMoney,
                  message: "Bitte geben Sie den Wert in Euro und Cent ein - zum Beispiel 136,15 oder 85,00",
                },
              ]}
              helperText={translate("employmentContract.claimedAmountClient.helperText", values)}
            />
          </Grid>
          <Grid sx={wizardStyle.gridTopSpaced} size={12}>
            <FormLegend>{translate("employmentContract.client.bankData.iban.question", values)}</FormLegend>
          </Grid>
          <Grid size={12}>
            <ValidatorTextField
              label="IBAN für Rückerstattung"
              name="client.bankData.iban"
              validators={[
                {
                  validator: isIban,
                  message: "Die eingegebene IBAN ist ungültig",
                },
              ]}
              InputProps={{
                startAdornment: <InputAdornment position="start">DE</InputAdornment>,
                inputComponent: IbanInput,
              }}
              helperText={translate("employmentContract.client.bankData.iban.helperText", values)}
            />
          </Grid>
        </>
      )}
      <ClientClaimedData />
    </>
  );
}
